import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';

import { Option } from 'components/core';
import { FormSelect } from './form-input';
import useKioskTerminals from '../use-kiosk-terminals';
import { InputContainer, InputLabel } from './components';

export default function DirectOrders(props): JSX.Element | null {
  const { dispensary } = props;
  const kioskTerminals = useKioskTerminals(dispensary);

  if (_.isEmpty(kioskTerminals)) {
    return null;
  }

  const defaultValue = kioskTerminals[0].id;

  return (
    <Container>
      <InputContainer>
        <InputLabel width='100px'>Pickup at:</InputLabel>
        <FormSelect name='destinationTerminal' defaultValue={defaultValue}>
          <Option value='' disabled>
            Select Terminal
          </Option>

          {_.map(kioskTerminals, (terminal) => (
            <Option key={terminal.id} value={terminal.id}>
              {terminal.nickname ?? terminal.id}
            </Option>
          ))}
        </FormSelect>
      </InputContainer>
    </Container>
  );
}

const Container = styled.div`
  margin-bottom: 30px;
`;
